import { render } from "./Icon.vue?vue&type=template&id=79f3b8dc&scoped=true&bindings={}"
import script from "./Icon.vue?vue&type=script&lang=ts"
export * from "./Icon.vue?vue&type=script&lang=ts"

import "./Icon.vue?vue&type=style&index=0&id=79f3b8dc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-79f3b8dc"

export default script